export default (value) => {
  value = parseFloat(value)
  if (isNaN(value)) {
    value = 0
  }
  value = value.toFixed(2)
  return '$' + value
}
